import { ErrorsComponent } from './../../core-content-manager/modals/errors/errors.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { URLs } from 'src/app/URLs';
import { GetService } from 'src/app/Services/get.service';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { contentLists } from 'src/app/core-content-manager/contentForms';
import { environment } from 'src/environments/environment';
import { PostService } from 'src/app/Services/post.service';
import { MatDialog } from '@angular/material/dialog';
import { SaveChangesComponent } from 'src/app/core-content-manager/modals/save-changes/save-changes.component';
import { SuccessComponent } from 'src/app/core-content-manager/modals/success/success.component';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-page-edit',
  templateUrl: './page-edit.component.html',
  styleUrls: ['./page-edit.component.scss'],
})
export class PageEditComponent implements OnInit, OnDestroy {
  viewClicked: boolean;


  subPagesUrl; //api link to subpages
  dataSection: any = null; // the whole sections array  data recieved from the api
  page: any;// the whole page data recieved from the api
  pageForm: FormGroup; // this for all page data;
  selectedItem: any; // the select in the top of page to select section scroll to
  lang: string = 'en'; // to check the language tab set english is default
  fieldsCtrls = {};//object of all controls in the form
  postEditLink: string; // the api link for posting form
  imageUrl; //image url in the backend api
  imageLinks = new Map();
  type: string = 'sections'; // by default this page of dynamic pages and only for sections ty[e]
  contentTypeData: any; // the data loaded for this type of content --here is sections
  forms = new Array();// array of all the forms in the page
  formsData = new Array(); //array of all sections  form data
  backendErrors = new Array();// array of all backend errors
  toggleShow=new Array();//array of showing the arabic images if select is image differenct
  fields: any;// array of the fields in the section form merged the en/arabic/comm/hidden
  imageSrc = { image: [], image_ar: [], icon: [], icon_ar: [], media:[], media_ar:[], dark_image:[], dark_image_ar:[] };//get all the image links to display
  imagesFieldsList = ['image', 'image_ar', 'icon', 'icon_ar', 'media', 'media_ar', 'dark_image', 'dark_image_ar']; // to deal with all image fields to handle them as special case in create form or formdata
  imageSizeError = { image: [], image_ar: [], icon: [], icon_ar: [], media:[], media_ar:[],dark_image:[], dark_image_ar:[] };//array to have the error of file input validation
  fileType ={ image: [], image_ar: [], icon: [], icon_ar: [], media:[], media_ar:[] , dark_image:[], dark_image_ar:[] };
  vaildationImageSize: boolean;//array to have the error of file input validation
  pageEditSubscribtions= new Subscription();
 pageEditPostSubscription= new Subscription();
  constructor(
    private route: ActivatedRoute,
    private service: GetService, private dialog:MatDialog,
    private spinner: NgxSpinnerService,
    private post: PostService,
    private elRef:ElementRef,
    public _domSanitizer: DomSanitizer
  ) {
  // get all data of section

   //make all field in single section  form
    this.imageUrl = environment.imgUrl;//get all image url backend
    // set the post link of api
  }

  ngOnInit() {
    this.spinner.show();
    if(this.route.snapshot.paramMap.get('type')=='offers'){
      this.subPagesUrl='dashboard/offers';
      this.type = 'offers_sections';
    }else{
      this.subPagesUrl = URLs.subPages;
    }
    console.log(this.type);
    
    this.contentTypeData = contentLists[this.type];
    this.postEditLink = contentLists[this.type].postEditLink;
    this.mergeFields();
   this.pageEditSubscribtions= this.service
      .get(this.subPagesUrl + '/' + this.route.snapshot.paramMap.get('id'))
      .subscribe((res) => {

         this.page = res.response.data;
        this.dataSection = res.response.data.sections;
console.log(this.page);

        //start create form data and sections forms
        for (
          let section_index = 0;
          section_index < this.dataSection.length;
          section_index++
        ) {
          this.formsData.push(new FormData());
          this.backendErrors.push( {});
          this.toggleShow.push( {});
          this.forms.push(new FormGroup(this.createForm(section_index,this.dataSection[section_index])));
          this.renderingSectionImages();
        }
      });
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
    setTimeout(() => {
      // this.renderingSectionImages();
    }, 800);


  }

  createForm(section_index,formValue) {

    let fieldsCtrls = {};
     let is_required;
    for (let f of this.fields) {

      //check if field is required
        if(f.required){
          is_required=Validators.required;
        }else{
          is_required=null
        }

      if (f.type != 'checkbox') {
        fieldsCtrls[f.name] = new FormControl(
          formValue[f.name],
        is_required
        );
        if (f.type == 'file') {
          this.imageSrc[f.name][section_index] = '';
            this.fileType[f.name][section_index] = '';


        }
        if(f.type=='radio'){

          if(formValue[f.name]== 0){
            let value=formValue[f.name];
            let show=(value==0)? false:true;


            this.toggleShow[section_index][f.name]=show;
          }
        }
      }
      // else {   //if type is checkbox
      //   // console.log( formValue[f.name]);
      //   let opts = {};
      //   for (let opt of f.options) {
      //     console.log(opt.key);

      //     opts[opt.key] = new FormControl(opt.value);
      //   }
      //   fieldsCtrls[f.name] = new FormGroup(opts);
      // }
      if(( formValue[f.name]==null ||  formValue[f.name]=='' || formValue[f.name]=='NULL') &&  formValue[f.name]!=0 ){

        this.toggleShow[section_index][f.name]=false;
      }else{
        this.toggleShow[section_index][f.name]=true;
     }
    }

    return fieldsCtrls;
  }
  triggerClick(fieldID) {
    document.getElementById(fieldID).click();
  }

  viewOnly() {
    this.viewClicked = true;
  }


  viewAndEdit() {
    this.viewClicked = false;
  }
updateRadioButton(fieldName,section_index,value){

let imageInput;
let title;
 if(fieldName=='is_media_different'){

  imageInput="media_ar";
  title="media_title_ar";
 }else if (fieldName=='is_dark_image_different'){
  imageInput="dark_image_ar";
  title="";
 }else{
  imageInput="icon_ar";
  title="";
 }
 let show=(value==0)? false:true;
 this.toggleShow[section_index][title]=show;
 this.toggleShow[section_index][imageInput]=show;
}
  submit(section_index) {
    this.forms[section_index].markAllAsTouched();

    var value;

    for (let f of this.fields) {


      if (
        f.name == 'image' ||
        f.name == 'image_ar' ||
        f.name == 'icon' ||
        f.name == 'icon_ar'||
        f.name == 'media' ||
        f.name == 'media_ar'||
        f.name == 'dark_image' ||
        f.name == 'dark_image_ar'
      ) {
      } else {
        value = this.forms[section_index].get(f.name).value ;
        if(value==null||value=='null'){value=''}

        if(this.formsData[section_index]?.get(f.name)?.value){
        this.formsData[section_index].set(f.name, value);

      }else{
          this.formsData[section_index].set(f.name, value);
      }
      }
    }
    this.spinner.show();
   this.pageEditPostSubscription = this.post
      .submit(
        this.postEditLink + this.forms[section_index]['value']['id'],
        this.formsData[section_index]
      )
      .subscribe(
        (res) => {
          setTimeout(() => {
            this.spinner.hide();
            this.dialog.open(SuccessComponent);
          }, 800);
        },
        (error) => {
          this.spinner.hide();
          this.backendErrors[section_index] = error.error.errors;

          for(let errElement in this.backendErrors[section_index]){
            for (let errItem = 0; errItem < this.backendErrors[section_index][errElement].length; errItem++) {
              const item = this.backendErrors[section_index][errElement][errItem];
            const dialogref = this.dialog.open(ErrorsComponent, {data: item})
            dialogref.afterClosed().subscribe((reply)=>{
             if(reply){
                  this.dialog.closeAll();
             }
            })
          }
          }
        }
      );
  }

  upload(event, fieldName, sectionIndex) {
    // this.progress = 1;
    
    const files: File = event.target.files;
    let chosenFile = files[0];
    
    
    this.fileType[fieldName][sectionIndex] = this.getFileType(chosenFile.name);
  
   
    
    let fileSize = Math.round(chosenFile.size / 1024);
    // console.log('fileSize', fileSize);
    let vaildSize: boolean = fileSize <= 9216 ? true : false;

    const reader = new FileReader();

    if (event.target.files.length && vaildSize) {
      this.imageSizeError[fieldName][sectionIndex] = false;
      const [file] = event.target.files;
      
      
      reader.readAsDataURL(file);

      reader.onload = () => {
        var obj = {};

        this.imageSrc[fieldName][sectionIndex] = reader.result as string;
        obj[fieldName] = event.target.files[0];
        this.formsData[sectionIndex].append(fieldName, event.target.files[0]);

      };
    } else {
      this.imageSizeError[fieldName][sectionIndex] = true;
    }
  }

  renderingSectionImages() {
    var key = '';
    var image;
    for (let i = 0; i < this.imagesFieldsList.length; i++) {
      key = this.imagesFieldsList[i]
      for (let x = 0; x < this.dataSection.length; x++) {

        image = this.imageUrl + this.dataSection[x][key];
        this.imageSizeError[key][x] = false;
        this.imageSrc[key][x] = image;

        this.fileType[key][x] = this.getFileType(this.dataSection[x][key]);



      }
    }
  }
  checkBoxvalue(event, id) {

    let data: any = { id: id, is_visible: Number(event) };
    this.service.Post(URLs.setSectionVisible + id, data).subscribe(
      (data) => {

      },
      (err) => {}
    );
  }


  scrollToSection(event) {

    var element = document.getElementById('section_' + event.value);


    setTimeout(function () {
      window.scrollTo({
        top: Number(element.offsetTop - 100),
        behavior: 'smooth',
      });
    }, 700);
  }

  mergeFields() {
    this.fields = this.contentTypeData.edit_form.english.concat(
      this.contentTypeData.edit_form.arabic,
      this.contentTypeData.edit_form.common,
      this.contentTypeData.edit_form.hidden
    );
  }

  openDialog(section_index){

    this.forms[section_index].markAllAsTouched();

    // if(this.forms[section_index].valid){
   const dialogref = this.dialog.open(SaveChangesComponent, {data:'Are You sure you want to save edits?'})
   dialogref.afterClosed().subscribe((reply)=>{;
    if(reply){
     this.submit(section_index);

    }
   })
  // }
  }


  getFileType(file, upload = '') {
    let images_array = [
      'png',
      'jpeg',
      'jpg',
      'gif',
      'svg',
      'image/*',
      'webp'
    ];
    let fileType: string = '';
    if (upload == 'upload') {
      fileType = file;
    } else {
      if (file != null && file != undefined) {
        fileType = file.split('.').pop();
      }
    }

    if (images_array.indexOf(fileType) > -1) {
      return 'image';
    } else {
      return 'video';
    }
  }
  ngOnDestroy(): void {
   this.pageEditSubscribtions.unsubscribe();
   this.pageEditPostSubscription.unsubscribe();

  }
}
